// Test tools → the test users: each one's role, password and, when 2-step is on, the code right now (so the real
// sign-in form can be tried without a phone), and "Sign in as" to jump straight in.
import { Badge } from '@the-kit/ui'
import { ROLE_LABEL } from '@/constants/roles'
import { useSignInAs, useTestUsers } from '../useDemoControls'

export function TestUsers({ onSignedIn }: { onSignedIn: () => void }) {
  const users = useTestUsers(true)
  const signInAs = useSignInAs()
  if (!users.data) return null
  return (
    <div className="space-y-2">
      {users.data.map(({ user, password, code }) => (
        <div key={user.id} className="rounded border border-slate-200 p-2.5 dark:border-slate-700">
          <div className="flex items-center gap-2">
            <b className="text-xs text-default">{user.name}</b>
            <span className="text-2xs text-primary-text">{ROLE_LABEL[user.role]}</span>
            {user.status !== 'active' && <Badge tone="gray">switched off</Badge>}
            <button
              type="button"
              className="btn btn-secondary btn-sm ml-auto"
              disabled={user.status !== 'active'}
              onClick={() => signInAs.mutate(user.id, { onSuccess: onSignedIn })}
              data-testid={'signin-' + user.id}
            >
              Sign in as
            </button>
          </div>
          <dl className="mt-1 grid grid-cols-[auto_1fr] gap-x-2 text-2xs text-muted">
            <dt>Email</dt>
            <dd className="truncate">{user.email}</dd>
            <dt>Password</dt>
            <dd className="mono select-all" data-testid={'test-password-' + user.id}>
              {password}
              {user.must_change_password && ' (one-time)'}
            </dd>
            <dt>2-step</dt>
            <dd className="mono" data-testid={'test-code-' + user.id}>
              {code ?? 'not set up'}
            </dd>
          </dl>
        </div>
      ))}
    </div>
  )
}
